import enUS from "antd/locale/en_US";
import frFR from "antd/locale/fr_FR";
import nlNL from "antd/locale/nl_NL";

// antd locale modules export { default: localeObj } where localeObj.locale is the lang code.
// Unwrap .default so callers get the locale object directly (e.g. antdLocaleFor("en").locale === "en").
const MAP = {
  en: enUS.default ?? enUS,
  fr: frFR.default ?? frFR,
  nl: nlNL.default ?? nlNL,
};

export function antdLocaleFor(lng) {
  return MAP[lng] || MAP.en;
}
